export const getMaxOrderContentSlider = [
  '',
  `query getMaxOrderContentSlider {
        getMaxOrderContentSlider
     }
  `,
  'getMaxOrderContentSlider'];
